import { JourneyChoiceGrid as ChoiceGrid } from "../../controls";

export const ProfileStep = ({ profileChoice, onChange }) => (
  <div>
    <h2 className="font-display text-3xl font-bold tracking-tight text-ink">We found information in your profile that may help establish your eligibility.</h2>
    <p className="mt-2 text-sm leading-6 text-slatey">OpenDegree can reuse relevant profile information for this opportunity only if you agree. You remain in control of what is used.</p>
    <div className="mt-6">
      <ChoiceGrid testId="journey-profile-use" value={profileChoice} onChange={onChange}
        options={[["yes", "Yes, use relevant information"], ["no", "No, answer only what is needed now"]]} />
    </div>
  </div>
);
